import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import apiService from '../../services/apiService';

const SendEmail = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await apiService.post('sendEmail', formData);
      
      if (response.data.success) {
        toast.error(response.data.message);
      } else {
        toast.success('Send Mail successfully');
        navigate('/send-mail');
        setFormData({ name: '', email: '' });
      }
    } catch (error) {
      console.error('Error sending email:', error);
      toast.error('Something went wrong, try again!!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      {/* Content */}
      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <form onSubmit={handleSubmit}>
            <div className="d-flex flex-column">
              {/* Form Card */}
              <div className="card card-flush py-4">
                <div className="card-body pt-0">
                  <div className="row">
                    <div className="col-md">
                      <label className="form-label my-2">
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        className="form-control form-control-solid py-6"
                        placeholder="Enter name..."
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md">
                      <label className="form-label my-2">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        className="form-control form-control-solid py-6"
                        placeholder="Enter email..."
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="d-flex justify-content-end">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                  style={{ backgroundColor: '#009ef7', borderColor: '#009ef7' }}
                >
                  {loading ? (
                    <>
                      <span className="indicator-progress">
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    </>
                  ) : (
                    <span className="indicator-label">Send Email</span>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SendEmail;
